export const SET_EDIT_NEWS_DATA = 'SET_EDIT_NEWS_DATA';

export function setEditNewsData(news) {
  return {
    type: SET_EDIT_NEWS_DATA,
    news,
  };
}
